/*
 * bstMatch.js — search matching for BST task ids (WR-013 §4).
 *
 * The WR requires `BST-42`, `bst-0042` and a bare `42` to all find BST-0042.
 * That means the numeric part has to be compared as a NUMBER, not as text:
 * "42" and "0042" are different strings but the same id.
 *
 * Mirrors backend/utils/bstId.js. The two are deliberately separate copies —
 * the containers share no module — so keep them in step.
 */

/** Does `bstId` match what the user typed? */
export function bstIdMatches(bstId, query) {
  if (!bstId || !query) return false;
  const raw = String(query).trim().toLowerCase();
  if (!raw) return false;

  // Plain substring first: catches "bst-00", "st-4", and full ids.
  if (String(bstId).toLowerCase().includes(raw)) return true;

  // Then numerically, so 42 == 0042.
  const q = raw.replace(/^bst[\s_-]*/, '');
  if (!/^\d+$/.test(q)) return false;
  const digits = String(bstId).replace(/^BST-/i, '');
  if (!/^\d+$/.test(digits)) return false;
  return String(parseInt(digits, 10)).startsWith(String(parseInt(q, 10)));
}

/** Free-text task match: title, description, or id. */
export function taskMatchesQuery(task, query) {
  const q = String(query || '').trim().toLowerCase();
  if (!q) return true;
  if (bstIdMatches(task.bstId, q)) return true;
  if (task.title && task.title.toLowerCase().includes(q)) return true;
  if (task.description && task.description.toLowerCase().includes(q)) return true;
  return false;
}
